import apiService from "../../../../services/api";

export const getTeamHierarchyDetais = async (companyId: string) => {
  return await apiService.get(`/companies/${companyId}/org-chart`);
};